module.exports = __webpack_public_path__ + "static/img/网站-网站UI设计.9c6c01e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10007/网站-网站UI设计.png
// module id = xRlo
// module chunks = 1